export default "__VITE_ASSET__166c8869__"